import { LogLevel } from "@azure/msal-browser";

var ua = window.navigator.userAgent;
var isIE = /MSIE|Trident/.test(ua);

const logLevelConfig = {
    'error': LogLevel.Error,
    'warning': LogLevel.Warning,
    'info': LogLevel.Info,
    'verbose': LogLevel.Verbose,
};

export const b2cPolicies = {
    names: {
        signUpSignIn: `B2C_1_HopSkip_Signin_${window.hopSkipConfig.auth.policyEnvironment}`,
        signUpOnly: `B2C_1_HopSkip_Signup_${window.hopSkipConfig.auth.policyEnvironment}`,
        checkout: `B2C_1_HopSkip_Checkout_${window.hopSkipConfig.auth.policyEnvironment}`
    },
    authorities: {
        signUpSignIn: {
            authority: `${window.hopSkipConfig.auth.loginDomain}/tfp/${window.hopSkipConfig.auth.tenant}/B2C_1_HopSkip_Signin_${window.hopSkipConfig.auth.policyEnvironment}`,
        },
        signUpOnly: {
            authority: `${window.hopSkipConfig.auth.loginDomain}/tfp/${window.hopSkipConfig.auth.tenant}/B2C_1_HopSkip_Signup_${window.hopSkipConfig.auth.policyEnvironment}`,
        },
        checkout: {
            authority: `${window.hopSkipConfig.auth.loginDomain}/tfp/${window.hopSkipConfig.auth.tenant}/B2C_1_HopSkip_Checkout_${window.hopSkipConfig.auth.policyEnvironment}`,
        }
    },
    authorityDomain: window.hopSkipConfig.auth.loginDomain
}

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: window.hopSkipConfig.auth.clientId,
        authority: /checkout/.test(window.location.hash)
            ? b2cPolicies.authorities.checkout.authority
            : /signup/.test(window.location.hash)
                ? b2cPolicies.authorities.signUpOnly.authority
                : b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: window.hopSkipConfig.clientRoot || window.hopSkipConfig.api.host, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: window.hopSkipConfig.clientRoot || window.hopSkipConfig.api.host, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        iframeHashTimeout: 10000,
        loggerOptions: {
            LogLevel: logLevelConfig[window.hopSkipConfig.auth.logLevel] || LogLevel.Error,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                if ((logLevelConfig[window.hopSkipConfig.auth.logLevel] || LogLevel.Error) < level) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    default:
                        console.log(message);
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: []
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    graphMe: {
        endpoint: "https://graph.microsoft.com/v1.0/me",
        scopes: ["User.Read"],
    },
    apiHopSkip: {
        endpoint: "https://book.myhopskip.com/api",
        scopes: [
            `${window.hopSkipConfig.auth.scopeIdentifierUri}/read`,
            `${window.hopSkipConfig.auth.scopeIdentifierUri}/write`,
            `${window.hopSkipConfig.auth.scopeIdentifierUri}/delete`,
        ],
    },
}